export enum VillasContentSections {
    OVERVIEW = 'overview',
    ROOMS_AND_AMENITIES = 'rooms-and-amenities',
    LOCATION = 'location',
    REVIEWS = 'reviews',
    THINGS_TO_KNOW = 'things-to-know',
  }

export const VILLAS_DISCOUNT_LABEL_COUNT = 1

// Months
export const VILLAS_MAXIMUM_TRAVEL_PERIOD_RANGE = 6
